import { injectIntl } from 'react-intl';
import AffiliationStore from './AffiliationStore';
import MembersStore from './MembersStore';
import AbstractRoot from '../../common_components/stores/AbstractRoot';

export default class RootStore extends AbstractRoot {
  constructor(
    invitations,
    memberships,
    features,
    permissions,
    currentUser,
    roles,
    modal,
    localeStore,
  ) {
    super(currentUser, roles, localeStore);
    this.roles = roles;
    this.modal = modal;
    this.affiliationStore = new AffiliationStore(
      this,
      invitations,
      memberships,
      features.roles,
      permissions,
    );
    this.membersStore = new MembersStore(
      this,
      memberships,
      features,
      permissions,
    );
  }
}
